import SysValidations from "config/lang/SysValidations";

const Validations = {
  ...SysValidations,
  articleRequired: "El artículo es requerido",
};

export default Validations;
